export default __webpack_public_path__ + "static/media/Cap of the Unslaked.5411d732.jpg";